"use strict";
/**
 * @author Hector J. Vasquez <ipi.vasquez@gmail.com>
 *
 * @licence
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const Graph_1 = require("../structures/Graph");
exports.Graph = Graph_1.default;
const Vertex_1 = require("../structures/Vertex");
exports.Vertex = Vertex_1.default;
const Edge_1 = require("../structures/Edge");
exports.Edge = Edge_1.default;
// Search algorithms
__export(require("./bfs"));
__export(require("./dfs"));
__export(require("./idfs"));
__export(require("./ucs"));
__export(require("./aStar"));
__export(require("./greedy"));
// TODO: Flow algorithms
// TODO: Dijkstra, Ford-Ful...



//////////////////
// WEBPACK FOOTER
// ./lib/graph/index.js
// module id = 34
// module chunks = 0